/**
 * ★ 2026-10-31 네이버 로그인 (OAuth Authorization Code 방식) — 카카오(config/kakao.js)와 같은 흐름.
 *
 *  흐름: 로그인 버튼 → naverAuthorizeUrl() 로 이동 → 네이버 인증 →
 *        /naverAuth 로 ?code=&state= 콜백 → 백엔드(/auth/naver)가 code+secret 으로 토큰 교환 → 자체 JWT 발급.
 *
 *  - client_id = REACT_APP_NAVER_CLIENT_ID (공개 값). Client Secret 은 백엔드 전용.
 *  - redirect_uri 는 현재 origin 기준 → 네이버 개발자센터 Callback URL 목록에 등록돼 있어야 한다
 *    (https://muyeon.co.kr/naverAuth, http://localhost:3000/naverAuth).
 *  - state 는 필수(CSRF 방지) — 무작위 값을 sessionStorage 에 두고, 돌아갈 경로를 함께 담는다.
 */
export const NAVER_CLIENT_ID = process.env.REACT_APP_NAVER_CLIENT_ID;
export const NAVER_REDIRECT_PATH = "/naverAuth";
const STATE_KEY = "muyeon.naverState";

export const naverRedirectUri = () => window.location.origin + NAVER_REDIRECT_PATH;

/** 네이버 인증 페이지 URL. redirect = 로그인 후 돌아갈 경로. */
export const naverAuthorizeUrl = (redirect) => {
  const nonce = Math.random().toString(36).slice(2) + Date.now().toString(36);
  try { sessionStorage.setItem(STATE_KEY, JSON.stringify({ nonce, redirect: redirect || "" })); } catch { /* 저장 못 하면 콜백에서 거절 */ }
  const params = new URLSearchParams({
    response_type: "code",
    client_id: NAVER_CLIENT_ID,
    redirect_uri: naverRedirectUri(),
    state: nonce,
  });
  return `https://nid.naver.com/oauth2.0/authorize?${params.toString()}`;
};

/** 콜백의 state 가 우리가 보낸 값인지 확인 → 맞으면 돌아갈 경로, 아니면 null. 한 번 쓰면 지운다. */
export const consumeNaverState = (state) => {
  let saved = null;
  try {
    saved = JSON.parse(sessionStorage.getItem(STATE_KEY) || "null");
    sessionStorage.removeItem(STATE_KEY);
  } catch { /* 없음 */ }
  if (!saved || !state || saved.nonce !== state) return null;
  return saved.redirect || "/home";
};

/**
 * ★ 2026-10-31 네이버 검수 전에는 버튼을 숨긴다 — '개발 중' 앱은 개발자센터 멤버관리에 등록한 아이디만 로그인되고,
 *  나머지 회원은 네이버 오류 화면을 본다. 테스트·검수용으로 /login?naver=1 로 들어오면 이 탭에서만 보인다.
 *  검수 승인 후 REACT_APP_NAVER_LOGIN_ENABLED=true 로 바꾸면 모두에게 보인다.
 */
const PREVIEW_KEY = "muyeon.naverPreview";
export const naverLoginVisible = (search = window.location.search) => {
  if (process.env.REACT_APP_NAVER_LOGIN_ENABLED === "true") return true;
  try {
    if (new URLSearchParams(search).get("naver") === "1") sessionStorage.setItem(PREVIEW_KEY, "1");
    return sessionStorage.getItem(PREVIEW_KEY) === "1";
  } catch {
    return false;
  }
};
